import './components/cookies';

(() => {
  const menuButton = document.querySelector('.menu-button');
  if (menuButton) {
    menuButton.addEventListener('click', function() {
    this.classList.toggle('fa-bars');
    this.classList.toggle('fa-close');
    document.querySelector('.main-menu').classList.toggle('hidden-m');
    document.querySelector('.navigation').classList.toggle('active');
   });
  }

  NodeList.prototype.forEach = Array.prototype.forEach; //Firefox compatibility
  let dropdowns = document.querySelectorAll('.dropdown > a');
  dropdowns.forEach(function(element) {
    element.addEventListener('click', function() {
      element.nextSibling.nextSibling.classList.toggle('hidden-m');
      element.parentNode.parentNode.parentNode.parentNode.classList.toggle(
        'active'
      );
    });
  });
})();

(() => {
  // Initialize counter
  let counter = parseInt(localStorage.getItem('fav_counter'));
  if (!isNaN(counter)) {
    let counter_element = document.getElementById('cupboard-general-counter');
    counter_element.textContent = counter;
  }
  // Update cupboard counter on Hashchange event.
  window.addEventListener(
    'hashchange',
    function() {
      let counter_element = document.getElementById('cupboard-general-counter');
      counter = parseInt(localStorage.getItem('fav_counter'));
      if (!isNaN(counter)) {
        counter_element.textContent = counter;
      }
    },
    false
  );
})();



// WEBPACK FOOTER //
// ./app/javascript/layout/index.js